// src/utils/customTemplateHelper.js
// Helper para detectar si un usuario/marca debe usar templates personalizados

// IDs específicos del cliente que necesita template personalizado
export const CUSTOM_TEMPLATE_USER_ID = '68fa4685635d5ec4280f8a50';
export const CUSTOM_TEMPLATE_MARCA_ID = '68fa4bcb635d5ec4280f8a89';

/**
 * Verifica si el usuario actual debe usar el template personalizado
 * @param {string} userId - ID del usuario
 * @param {Array} marcas - Array de marcas del usuario
 * @returns {boolean} - true si debe usar template personalizado
 */
export const shouldUseCustomTemplate = (userId, marcas = []) => {
  // Verificar por userId
  if (userId === CUSTOM_TEMPLATE_USER_ID) {
    return true;
  }

  // Verificar por marcaId
  if (marcas && marcas.length > 0) {
    const hasCustomMarca = marcas.some(marca => marca._id === CUSTOM_TEMPLATE_MARCA_ID);
    if (hasCustomMarca) {
      return true;
    }
  }

  return false;
};

/**
 * Hook helper para obtener marcas del usuario y verificar template
 * Esta función puede ser usada en componentes que necesiten verificar
 */
export const checkCustomTemplate = async (userId, getMarcasFn) => {
  if (!userId) return false;

  // Si el userId coincide directamente
  if (userId === CUSTOM_TEMPLATE_USER_ID) {
    return true;
  }

  // Si hay función para obtener marcas, verificar por marca
  if (getMarcasFn) {
    try {
      const marcas = await getMarcasFn(userId);
      return shouldUseCustomTemplate(userId, marcas);
    } catch (error) {
      console.error('Error checking custom template:', error);
      return false;
    }
  }

  return false;
};

/**
 * Verifica si una marca específica debe usar el template personalizado
 * @param {string} marcaId - ID de la marca
 * @returns {boolean} - true si debe usar template personalizado
 */
export const shouldUseCustomTemplateByMarcaId = (marcaId) => {
  return marcaId === CUSTOM_TEMPLATE_MARCA_ID;
};

